module.exports = __webpack_public_path__ + "img/circle4.c9c39ac9.svg";